import { makeImmutable } from "../../core/makeImmutable";
export class CustomParameterBasedProductSelector {
    constructor(params) {
        this.kind = "CustomParameter";
        this.customParameterType = params.customParameterType;
        this.allowedChoices = params.allowedChoices;
        makeImmutable(this);
    }
    test(productInstance) {
        throw new Error("TODO Not implemented yet");
    }
}
